import React from "react";
import { Box, Typography } from "@mui/material";

const ParentalControl = () => {
  return (
    <Box sx={{ padding: "20px", maxWidth: "800px", margin: "auto" }}>
      <Typography variant="subtitle1" gutterBottom>
        Last updated on Nov 27th 2024
      </Typography>
      <Typography variant="body1" paragraph>
        We request parents/seniors @ home to oversee and monitor the internet usage in their house.
        We advise them to adopt necessary filters and access restrictions to ensure proper usage.
      </Typography>

      <Typography variant="h6" gutterBottom>
        Customers:
      </Typography>
      <Typography variant="body1" paragraph>
        Customers are requested to take sufficient precaution towards the access controls of their
        IPs both static and dynamic. It is of paramount importance that your ILL/BB Residential line
        is inaccessible to elements who are security threats to the country and society.
      </Typography>
    </Box>
  );
};

export default ParentalControl;
